import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import RichText from 'components/RichText';
import Theme from 'styles/theme';

const SubHeader = ({ text }) => (
  <div className="SubHeader">
    {!isEmpty(text) && <RichText content={text} />}
    <style jsx>
      {`
        .SubHeader {
          margin-top: ${Theme.get('spacing') * 8}px;
        }
      `}
    </style>
  </div>
);

SubHeader.propTypes = {
  text: PropTypes.shape({}),
};

SubHeader.defaultProps = {
  text: {},
};

export default SubHeader;
